import { render, staticRenderFns } from "./TikTokPostGrid.vue?vue&type=template&id=8c57604c"
import script from "./TikTokPostGrid.vue?vue&type=script&lang=ts"
export * from "./TikTokPostGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports